import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = [
  '!FETCH_COMPANY_ACTIVITY_CODES',
  '!FETCH_LAST_TAX',
  '!FETCH_TAX_GROUP_PAYMENT_HISTORY_V2',
  '!FETCH_TAX_LIST_BY_PAGING_V2',
  '!FETCH_TAX_PAYMENT_HISTORY_V2',
  '!INIT_TAX_LIST_PAGE_LOAD',
  '!RESET_PAGINATION',
  '!START_BULK_EXPORT_V2',
  '!STOP_BULK_EXPORT_V2',
  '!TRIGGER_TAX_LIST_UPDATE',
  'BULK_DELETE_V2',
  'BULK_TAGGING_V2',
  'FETCH_TAX_LIST_V2',
  'UPDATE_ORDER_V2',
  'UPDATE_ROWS_PER_PAGE_V2',
] as const

export default serviceActionsGenerator('tax', actionTypes)
